module.exports = __webpack_public_path__ + "media/images/icon-claim-complete-cae2cd4ce54387bfd9257df3060b8127.svg";